import controller from './massia.header.controller';

export default {
    template: require('./header.tpl.html'),
    controller: controller
};
